import { useState } from 'react';

function OpenandCloseModal() {
  const [openModal, setOpenModal] = useState('close');
  const [offerDetails, setOfferDetails] = useState([]);
  const [cxId, setCxId] = useState(0);

  const handleOpenandCloseModal = (tag) => {
    setOpenModal(tag);
  };

  return {
    openModal,
    handleOpenandCloseModal,
    setOfferDetails,
    offerDetails,
    cxId,
    setCxId,
  };
}

export default OpenandCloseModal;
